import React, { Suspense } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import I10n from '../features/i10n';
import Button from '../atoms/button';
import MsxIcons from '../features/msx-icons';
import MachineExpertPopupDisplayer from './machine_expert_popup_displayer';
import LoadingSpinner from '../atoms/loading';
import DocumentationDropdown from './documentation/documentation_dropdown';
import ExportLink from './documentation/export_link';
import { appConfiguration } from '../utils/app-starter';
import { PRIMARY_COLOR } from '../color-constants';
import { possible_starter_selections } from '../constants';
const PDFExportWrapper = React.lazy(() => import('./pdf_export_wrapper'));

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 10px 0px 10px;
  @media (max-width: 800px) {
    padding: 10px 0px 0px 0px;
  }
`;

const SavedTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SavedTitle = styled.span`
  font-size: 18px;
  font-weight: bold;
  color: #626469;
  margin-left: 5px;

`;

const ClipboardAndButtonsWrapper = styled.div`
  background-color: rgb(249, 249, 249);
  padding: 10px;
  margin-bottom: 10px;
`;

const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const MarginWrapper = styled.div`
  margin-top: 10px;
`;

const FullRowMarginWrapper = styled(MarginWrapper)`
  width: 100%;
`;

const SpinnerWrapper = styled.div`
  margin-left: 10px;
  display: flex;
  justify-content: center;
`;


const WorkspaceCol = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
`;

const SavedIconAndLabelWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const SavedConfigurationIcon = styled.div`
  color: ${PRIMARY_COLOR};
  color: var(--se-secondary, ${PRIMARY_COLOR});
`;

const SavedConfigurationLabel = styled.span`
  font-weight: 400;
  font-size: 18px;
  margin-left: 10px;
`;

const ViewMoreOptionsWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 10px;
  color: ${PRIMARY_COLOR};
  color: var(--se-secondary, ${PRIMARY_COLOR});
  cursor: pointer;
`;

const ViewMoreOptionsLabel = styled.span`
  font-size: 16px;
  font-weight: 400;
  margin-right: 10px;
`;

const OpenIconWrapper = styled.div`
  transform: ${props => props.isOpen ? 'rotate(-180deg)' : 'rotate(0deg)'};
  width: 32px;
  height: 32px;
  box-sizing: content-box;
  display: flex;
  justify-content: center;
  align-items: center;
`;


const MachineExpertTitleWrapper = styled.div`
    display: flex;
    align-items: center;
`;

const MachineExpertTitle = styled.span`
  font-weight: 400;
  font-size: 12px;
  color: #626469;
  word-break: break-word;
  margin-right: 5px;
`;

const ShareSectionWrapper = styled.div`
  margin-bottom: 5px;
`;

const DesktopButtonsWrapper = styled.div`
  display: block;
  @media (max-width: 800px) {
    display: none;
  }
`;

const MobileButtonsWrapper = styled.div`
  display: none;
  @media (max-width: 800px) {
    display: block;
  }
`;

class SavedConfigurationSection extends React.Component {

  static propTypes = {
    configuration: PropTypes.object,
    exportToMachineExpert: PropTypes.func,
    exportToPng: PropTypes.func,
    exportToXls: PropTypes.func,
    exportToAml: PropTypes.func,
    addToMyProduct: PropTypes.func,
    addToMyList: PropTypes.func,
    addToMyProductLabel: PropTypes.string,
    addToListLabel: PropTypes.string,
    export: PropTypes.object,
    showNotification: PropTypes.func,
    handleEmailFormOpen: PropTypes.func,
    openModal: PropTypes.func,
    closeModal: PropTypes.func,
    isWrapperMode: PropTypes.bool,
    allowSavedModifications: PropTypes.bool,
    workspaceOptionsOpened: PropTypes.bool,
    toggleWorkspaceOptions: PropTypes.func,
    seamlessSession: PropTypes.object,
    launchFromWorkspace: PropTypes.bool,
    isWorkspaceAvailable: PropTypes.bool,
    unifiedCheckoutAvailable: PropTypes.bool
  }

  copyToClipboard = text => {
    const el = document.createElement('textarea');
    el.value = text;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    this.props.showNotification(I10n.get('saved_configuration.copy_clipboard.notification'), 'success', () => null);
  }


  renderExportLinks = () => {
    const components = [];
    if (this.props.configuration.rangeInfo.canExportToMachineExpert) {
      components.push(
        <ExportLink
          key={'machine-expert'}
          renderTitleComponent={() => <MachineExpertTitleWrapper>
            <MachineExpertTitle>{I10n.get('saved_configuration.export.machine_expert')}</MachineExpertTitle>
            <MachineExpertPopupDisplayer
              openModal={this.props.openModal}
              closeModal={this.props.closeModal}
              starterType={this.props.configuration.starterType}
            >
            </MachineExpertPopupDisplayer>
          </MachineExpertTitleWrapper>}
          name={I10n.get('saved_configuration.export.machine_expert')}
          onDownload={() => {
            this.props.exportToMachineExpert(this.props.configuration);
          }}
          loading={this.props.export.machine_expert.isLoading}
          extensionLabel={".py"}
        >
        </ExportLink>
      );
    }
    components.push(
      <ExportLink
        key={'export.png'}
        name={I10n.get('saved_configuration.export.png')}
        onDownload={() => {
          this.props.exportToPng(this.props.configuration);
        }}
        loading={this.props.export.png.isLoading}
        extensionLabel={".zip"}
      >
      </ExportLink>
    );

    components.push(
      <ExportLink
        key={'export.xls'}
        name={I10n.get('saved_configuration.export.xls')}
        onDownload={() => {
          this.props.exportToXls(this.props.configuration);
        }}
        loading={this.props.export.xls.isLoading}
        extensionLabel={".xls"}
      >
      </ExportLink>
    );

    if (false) {
      components.push(
        <ExportLink
          name={I10n.get('saved_configuration.export.aml')}
          onDownload={() => {
            this.props.exportToAml(this.props.configuration);
          }}
          loading={this.props.export.aml.isLoading}
          extensionLabel={".aml"}
        >
        </ExportLink>
      );
    }

    components.push(
      <Suspense key={'pdf-exports'} fallback={<>
        <ExportLink
          name={I10n.get('saved_configuration.export.pdf')}
          onDownload={() => {}}
          loading={true}
          extensionLabel={".pdf"}
        >
        </ExportLink>
        <ExportLink
          name={I10n.get('saved_configuration.export.pdf_architecture')}
          onDownload={() => {}}
          loading={true}
          extensionLabel={".pdf"}
        >
        </ExportLink>
      </>}>
          <PDFExportWrapper configuration={this.props.configuration}></PDFExportWrapper>
      </Suspense>
    );

    if (possible_starter_selections.EDGE === this.props.configuration.starterType) {
      components.push(
        <ExportLink
          key={'export.3d-view'}
          name={I10n.get('saved_configuration.export.3d-view')}
          onDownload={() => {
            this.props.openModal({
              modalType: 'edge-3d-viewer',
              modalProps: {
                configuration: this.props.configuration,
                showExports: true
              }
            });
          }}
          loading={false}
          extensionLabel={""}
        >
        </ExportLink>
      );
    }
    return components;
  }

  renderShareLinks = () => {
    const components = [];
    components.push(
      <ExportLink
        key={'share.configuration-id'}
        name={I10n.get('saved_configuration.copy_conf_id')}
        onDownload={() => {
          this.copyToClipboard(this.props.configuration.id);
        }}
        loading={false}
        extensionLabel={""}
        hideIcon={true}
      >
      </ExportLink>
    );

    if (appConfiguration.locale !== 'zh-CN') {
      components.push(
        <ExportLink
          key={'share.configuration-id'}
          name={I10n.get('saved_configuration.send_by_mail')}
          onDownload={() => {
            this.props.handleEmailFormOpen(this.props.configuration);
          }}
          loading={false}
          extensionLabel={""}
          hideIcon={true}
        >
        </ExportLink>
      );
    }

    return components;
  }

  renderOptions = () => {
    const nbExports = this.props.configuration.rangeInfo.canExportToMachineExpert ? 5 : 4;

    return (
      <>
        <ShareSectionWrapper>
          <DocumentationDropdown defaultOpenStatus={window.innerWidth > 800}
            title={`${I10n.get('share_menu')}`}
            children={this.renderShareLinks()}>
          </DocumentationDropdown>
        </ShareSectionWrapper>
        <DocumentationDropdown defaultOpenStatus={window.innerWidth > 800}
          title={`${I10n.get('menu_export')} (${nbExports})`}
          children={this.renderExportLinks()}>
        </DocumentationDropdown>
      </>
    );
  }

  renderButtons = () => {
    let addToMyProductLabel = I10n.get('saved_configuration.export.my_product');
    let addToMyProductIcon = 'star';

    if (this.props.unifiedCheckoutAvailable) {
      addToMyProductLabel = I10n.get('saved_configuration.export.add_to_my_cart');
      addToMyProductIcon = 'shopping-cart';
    } else if (this.props.isWorkspaceAvailable) {
      addToMyProductLabel = I10n.get('saved_configuration.export.my_project');
      addToMyProductIcon = 'bag-plus';
    }

    return (
      <ClipboardAndButtonsWrapper>
        {this.props.allowSavedModifications && <SavedTitleWrapper>
          <MsxIcons name="selected" color="primary" size="large"></MsxIcons>
          <SavedTitle>{I10n.get('saved_configuration.configuration_saved')}</SavedTitle>
        </SavedTitleWrapper>}
        <ButtonsWrapper>
          {this.props.unifiedCheckoutAvailable && <MarginWrapper>
            <Button expand={true} icon-name="list-bullets" onClick={() => {
              this.props.addToMyList(this.props.configuration);
            }}>
              {this.props.addToListLabel ? this.props.addToListLabel : I10n.get('saved_configuration.export.add_to_my_list')}
            </Button>
          </MarginWrapper>}

          {(this.props.isWrapperMode) ?
            <MarginWrapper>
              <Button expand={true} importance="emphasized" icon-name={'shopping-cart'} disabled={this.props.export.my_product.isLoading} onClick={() => { this.props.addToMyProduct(this.props.configuration); }}>
                {this.props.export.my_product.isLoading ? <SpinnerWrapper><LoadingSpinner width="10px" height="10px"></LoadingSpinner></SpinnerWrapper> :
                  this.props.addToMyProductLabel ? this.props.addToMyProductLabel : I10n.get('saved_configuration.export.add_cart')
                }
              </Button>
            </MarginWrapper>
            :
            <MarginWrapper>
              <Button expand={true} importance="emphasized" icon-name={addToMyProductIcon} primary disabled={this.props.export.my_product.isLoading} onClick={() => { this.props.addToMyProduct(this.props.configuration); }}>
                {this.props.export.my_product.isLoading ? <SpinnerWrapper><LoadingSpinner width="10px" height="10px"></LoadingSpinner></SpinnerWrapper> :
                  addToMyProductLabel
                }
              </Button>
            </MarginWrapper>
          }

        </ButtonsWrapper>
      </ClipboardAndButtonsWrapper>
    );
  }

  renderDefaultSavedSection = () => {
    return (
      <>
        <DesktopButtonsWrapper>
          {this.renderButtons()}
        </DesktopButtonsWrapper>
        <MobileButtonsWrapper>
          {this.renderButtons()}
        </MobileButtonsWrapper>
      </>
    );
  }

  renderWorkspaceSavedSection = () => {
    let addToMyProjectLabel = I10n.get('saved_configuration.export.my_project');
    let addToMyProjectIcon = 'plus-circle';
    if (this.props.unifiedCheckoutAvailable) {
      addToMyProjectLabel = I10n.get('saved_configuration.export.add_to_my_cart');
      addToMyProjectIcon = 'shopping-cart';
    }
    if (this.props.addToMyProductLabel) {
      addToMyProjectLabel = this.props.addToMyProductLabel;
    }
    return (<WorkspaceCol>
      {this.props.allowSavedModifications && <SavedIconAndLabelWrapper>
        <SavedConfigurationIcon>
          <MsxIcons name="selected"></MsxIcons>
        </SavedConfigurationIcon>
        <SavedConfigurationLabel>{I10n.get('saved_configuration.configuration_saved')}</SavedConfigurationLabel>
      </SavedIconAndLabelWrapper>}
      {this.props.unifiedCheckoutAvailable &&
        <FullRowMarginWrapper>
          <Button expand={true} icon-name="list-bullets" onClick={() => {
            this.props.addToMyList(this.props.configuration);
          }}>
            {this.props.addToListLabel ? this.props.addToListLabel : I10n.get('saved_configuration.export.add_to_my_list')}
          </Button>
        </FullRowMarginWrapper>
      }
      <FullRowMarginWrapper>
        <Button importance="emphasized" expand={true} icon-name={addToMyProjectIcon} disabled={this.props.export.my_product.isLoading} onClick={() => { this.props.addToMyProduct(this.props.configuration); }}>
          {addToMyProjectLabel}
        </Button>
      </FullRowMarginWrapper>
      <ViewMoreOptionsWrapper onClick={this.props.toggleWorkspaceOptions}>
        <ViewMoreOptionsLabel>{I10n.get('saved_configuration.view_more_options')}</ViewMoreOptionsLabel>
        <OpenIconWrapper isOpen={this.props.workspaceOptionsOpened} >
          <MsxIcons name="down-arrow" size="small"></MsxIcons>
        </OpenIconWrapper>
      </ViewMoreOptionsWrapper>
    </WorkspaceCol>);
  }

  render = () => {
    return (
      <Container>
        {(this.props.launchFromWorkspace || (this.props.unifiedCheckoutAvailable && this.props.isWrapperMode)) ? this.renderWorkspaceSavedSection() : this.renderDefaultSavedSection()}
        {((!this.props.launchFromWorkspace && !(this.props.unifiedCheckoutAvailable && this.props.isWrapperMode)) || this.props.workspaceOptionsOpened) && this.renderOptions()}
      </Container>
    );
  };

}
export default SavedConfigurationSection;

